import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import React from 'react';
import { useProductCategoryProvider } from '../ProductCategory.Hooks';

export default function ProductCategoryDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useProductCategoryProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.code}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
